<div>Schedule <span (click)="reload()">(reload)</span></div>
<div class="sequence" *ngFor="let event of serviceEvents; let idx = index; trackBy: trackByFn">
  <div class="f-row">
    <div class="sequence-number strong">{{ idx + 1 }}</div>
    <div>
      <div>
        <span *ngIf="isSchoolService">Teacher: {{ getUserFullName(event.account) }}</span>
        <span>Time: {{ event.begin_at | dfnsFormat:"PPp" }} &mdash; {{ event.end_at | dfnsFormat: "PPp" }}</span>
      </div>
      <div>
        <span *ngIf="event.meetingsLimit > 1">Classes: {{ event.meetingsLimit }}</span>
        <span>{{ weekdays(event) }}</span>
        <span *ngIf="event.participants_limit > 1">{{ event.participants_left }} of {{ event.participants_limit }} places left</span>
        <a *ngIf="event.meeting?.classroom" [routerLink]="classroomRoute(event.meeting?.classroom)">➡️ {{ event.meeting?.classroom.title }}</a>
      </div>
    </div>
    <div *ngIf="event.is.participant" class="btn btn-success">already signed</div>
  </div>
  <!--<pre>{{ event | json }}</pre>-->
  <div class="sequence-events">
    <div *ngFor="let seqEvent of event.events; let seqIdx = index; trackBy: trackByFn" [ngClass]="seqEventCssClass(seqEvent)">
      <span class="event-number strong">{{ idx + 1 }}.{{seqIdx + 1}}.</span>
      <span class="status">{{ statusName(seqEvent.status) }}:{{ generationStatusName(seqEvent.generation_status) }}</span>
      <span>Meeting {{ seqEvent.details?.sequence_number || '?' }} of {{ seqEvent.details?.sequence_total || '?'}}</span>
      <span>Time: {{ seqEvent.begin_at | dfnsFormat:"ccc PPp" }} &mdash; {{ seqEvent.end_at | dfnsFormat: "p" }}</span>
      <a *ngIf="seqEvent.meeting" [routerLink]="meetingRoute(seqEvent.meeting)">➡️ {{ seqEvent.meeting.title }}</a>
      <!--<pre>{{ seqEvent | json }}</pre>-->
    </div>
  </div>
</div>
